import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import SideNav from "./components/sideNav";
import {h2Unlinked, castCard, calender, makeCalenderLink} from "./core/core";
import { apiRoot } from "./core/defines"
import useCastEffect from "./service/useCastData";

function getSeletcedW(param){

    let selectedW = new Date().getDay()
    if(param !== undefined){ selectedW = param.split("_")[1] }
    return selectedW
}

function Schedule(){
    const {dateParam} = useParams();
    const [casts,   setCasts] = useState([]);
    const [day,   setDay] = useState(0);

    const{fetchSchedule}=useCastEffect()

    useEffect(()=>{

        const init =async()=>{
            console.log(dateParam)
            const param=dateParam===undefined
                            ? null
                            : dateParam

            const d=await fetchSchedule({date: param})
            if(d){
                setCasts(d.data)
            }
        }

        const d=dateParam ===undefined
                ? new Date().getDay()
                : new Date(dateParam).getDay()

        setDay(d)

        init()

    },[]);

    return(
        <div className="container bg-w-alpha">
            <article className="main-colmn">
                {h2Unlinked("出勤スケジュール")}
                <nav className="block-calender" >{ makeCalenderLink(calender(), day) }</nav>
                    <ul className="wrapper-c-lists">
                        {casts.map((c)=>
                            <li key={c.c_id} className="card-cast">
                                {castCard(c)}
                            </li>
                        )}
                    </ul>
            </article>
            <SideNav />
        </div>
    );
}

export default Schedule;